import { render, staticRenderFns } from "./patterns.vue?vue&type=template&id=b4de5c7a"
import script from "./patterns.vue?vue&type=script&lang=js"
export * from "./patterns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports